import request from 'services/request';
import { endpoints } from 'services';
import { paramsToFormData } from 'utils/utils';

export default {
  postSales: (params: ProjectListReqDto): Promise<ManagementListResDto> =>
    request({
      url: endpoints.management.sales,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postSalesDetail: (params: ProjectListReqDto): Promise<CommonListResDto> =>
    request({
      url: endpoints.management.salesDetail,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postClose: (params: ProjectListReqDto): Promise<CommonListResDto> =>
    request({
      url: endpoints.management.close,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postCloseDetail: (params: CloseHistoryListReqDto): Promise<CommonListResDto> =>
    request({
      url: endpoints.management.closeDetail,
      method: 'post',
      data: paramsToFormData(params),
    }),    
   postCloseUpdate: (params: CloseUpdateReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.management.closeUpdate,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postLecturer: (params: ProjectListReqDto): Promise<CommonListResDto> =>
    request({
      url: endpoints.management.lecturer,
      method: 'post',
      data: paramsToFormData(params),
    }),  
  postLecturerDetail: (params: ProjectListReqDto): Promise<CommonListResDto> =>
    request({
      url: endpoints.management.lecturerDetail,
      method: 'post',
      data: paramsToFormData(params),
    }),  
  postIndicatorYear: (params: ProjectListReqDto): Promise<indicatorListResDto> =>
    request({
      url: endpoints.management.indicators.year,
      method: 'post',
      data: paramsToFormData(params),
    }),  
  postIndicatorDay: (params: ProjectListReqDto): Promise<indicatorListResDto> =>
    request({
      url: endpoints.management.indicators.day,
      method: 'post',
      data: paramsToFormData(params),
    }),  
  postIndicatorRange: (params: ProjectListReqDto): Promise<indicatorListResDto> =>
    request({
      url: endpoints.management.indicators.range,
      method: 'post',
      data: paramsToFormData(params),      
    }),   
  postIndicatorTop: (params: ProjectListReqDto): Promise<indicatorListResDto> =>
    request({
      url: endpoints.management.indicators.top,
      method: 'post',
      data: paramsToFormData(params),
    }),   
  postIndicatorNew: (params: ProjectListReqDto): Promise<indicatorListResDto> =>
    request({
      url: endpoints.management.indicators.new,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postIndicatorType: (params: ProjectListReqDto): Promise<indicatorListResDto> =>
    request({
      url: endpoints.management.indicators.type,
      method: 'post',
      data: paramsToFormData(params),
    }), 
  postIndicatorContent: (params: ProjectListReqDto): Promise<indicatorListResDto> =>
    request({
      url: endpoints.management.indicators.content,
      method: 'post',
      data: paramsToFormData(params),
    }),     
  postIndicatorTypeUpdateValue: (params: indicatorValueReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.management.indicators.val.updateType,
      method: 'post',
      data: paramsToFormData(params),
    }),   
  postIndicatorAsk: (params: ProjectListReqDto): Promise<indicatorListResDto> =>
    request({
      url: endpoints.management.indicators.ask,
      method: 'post',
      data: paramsToFormData(params),
    }),  
  postIndicatorLecturer: (): Promise<indicatorListResDto> =>
    request({
      url: endpoints.management.indicators.lecturer,
      method: 'post',
    }),  
  postIndicatorSubjectTop: (params: ProjectListReqDto): Promise<indicatorListResDto> =>
    request({
      url: endpoints.management.indicators.subjectTop,
      method: 'post',
      data: paramsToFormData(params),
    }),                                 
};


